"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWeekdayName = exports.getWeekdayNumber = exports.getWeekdayKey = void 0;
// File: deliveryRulesUtils.ts
const deliveryRulesConstants_1 = require("./deliveryRulesConstants");
const getWeekdayKey = (weekday) => {
    if (!isNaN(Number(weekday))) {
        return deliveryRulesConstants_1.weekdaysMapping[weekday];
    }
    return weekday;
};
exports.getWeekdayKey = getWeekdayKey;
const getWeekdayNumber = (weekday) => {
    if (!isNaN(Number(weekday))) {
        return weekday;
    }
    return deliveryRulesConstants_1.weekdaysMapping[weekday];
};
exports.getWeekdayNumber = getWeekdayNumber;
const getWeekdayName = (weekday) => {
    const key = (0, exports.getWeekdayKey)(weekday);
    return deliveryRulesConstants_1.weekdayMap[key]?.value;
};
exports.getWeekdayName = getWeekdayName;
